import BillingEntitiesService from "@/api/services/billingEntities";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  billingEntities: [],
  currentPage: 1,
  totalPages: 1,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    billingEntities: (state) => state.billingEntities,
  },
  mutations: {
    SET_BILLING_ENTITIES(state, { billingEntities, page }) {
      state.billingEntities = billingEntities;
      state.currentPage = page.currentPage;
      state.totalPages = page.totalPages;
      state.totalCount = page.totalCount;
    },
  },
  actions: {
    async fetch(_, { id, includes = [] }) {
      const response = await BillingEntitiesService.fetchBillingEntity(id, { includes });
      if (!response?.success) return response;
      return toCamelCase(response.data);
    },
    async fetchIndex({ commit }, { organizationId, page = 1, perPage = null, includes = ["iban", "stores"] } = {}) {
      const response = await BillingEntitiesService.fetchBillingEntities({
        organizationId,
        page,
        perPage,
        includes,
      });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("SET_BILLING_ENTITIES", data);
      return data.billingEntities;
    },
    async create(_, payload) {
      const response = await BillingEntitiesService.createBillingEntity(payload);
      if (!response?.success) return null;
      return toCamelCase(response.data);
    },
    async update(_, { id, ...payload }) {
      const response = await BillingEntitiesService.updateBillingEntity(id, payload);
      if (!response?.success) return null;
      return toCamelCase(response.data);
    },
  },
};
